import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Целевой блок может появиться позже (ленивая загрузка страницы) —
      // повторяем поиск, пока не найдём его или не выйдет время.
      const id = decodeURIComponent(hash.slice(1));
      let tries = 0;
      let timer = null;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (tries++ < 30) {
          timer = setTimeout(tryScroll, 100);
        }
      };
      tryScroll();
      return () => timer && clearTimeout(timer);
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    return undefined;
  }, [pathname, hash]);

  return null;
}
